var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvcIcon7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8458 10C16.199 10 10 16.1992 10 23.846C10 31.4929 16.199 37.692 23.8458 37.692C31.4927 37.692 37.6917 31.4929 37.6917 23.846C37.6917 16.1992 31.4927 10 23.8458 10Z",
    fill: "#9AFF42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8458 42.3081C16.199 42.3081 10 48.5073 10 56.1541C10 63.801 16.199 70.0001 23.8458 70.0001C31.4927 70.0001 37.6917 63.801 37.6917 56.1541C37.6917 48.5073 31.4927 42.3081 23.8458 42.3081Z",
    fill: "#38383D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1542 26.1538H52.6927V33.0768V34.8076V36.5383H50.962H49.2313H42.3083V39.9998V43.4613H49.2313H50.962H52.6927V45.1921V46.9228V53.8458H56.1542H59.6157V46.9228V45.1921V43.4613H61.3464H63.0771H70V39.9998V36.5383H63.0771H61.3464H59.6157V34.8076V33.0768V26.1538H56.1542Z",
    fill: "#9AFF42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2313 36.5383V34.8076H44.0391C43.0832 34.8076 42.3083 35.5824 42.3083 36.5383H49.2313Z",
    fill: "#9AFF42"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2313 36.5383H50.962V34.8076H49.2313V36.5383Z",
    fill: "#9AFF42"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6927 36.5383V34.8076H50.962V36.5383H52.6927Z",
    fill: "#9AFF42"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6927 33.0768H50.962V34.8076H52.6927V33.0768Z",
    fill: "#9AFF42"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6927 33.0768V26.1538C51.7369 26.1538 50.962 26.9287 50.962 27.8845V33.0768H52.6927Z",
    fill: "#9AFF42"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6157 46.9228V53.8458C60.5715 53.8458 61.3464 53.0709 61.3464 52.1151V46.9228H59.6157Z",
    fill: "#9AFF42"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6157 45.1921V46.9228H61.3464V45.1921H59.6157Z",
    fill: "#9AFF42"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3464 43.4613H59.6157V45.1921H61.3464V43.4613Z",
    fill: "#9AFF42"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6927 45.1921V43.4613H50.962V45.1921H52.6927Z",
    fill: "#9AFF42"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.962 46.9228H52.6927V45.1921H50.962V46.9228Z",
    fill: "#9AFF42"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6927 53.8458V46.9228H50.962V52.1151C50.962 53.0709 51.7369 53.8458 52.6927 53.8458Z",
    fill: "#9AFF42"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2313 43.4613V45.1921H50.962V43.4613H49.2313Z",
    fill: "#9AFF42"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2313 43.4613H42.3083C42.3083 44.4172 43.0832 45.1921 44.0391 45.1921H49.2313V43.4613Z",
    fill: "#9AFF42"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6157 36.5383H61.3464V34.8076H59.6157V36.5383Z",
    fill: "#9AFF42"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0771 36.5383V34.8076H61.3464V36.5383H63.0771Z",
    fill: "#9AFF42"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0771 36.5383H70C70 35.5824 69.2252 34.8076 68.2693 34.8076H63.0771V36.5383Z",
    fill: "#9AFF42"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0771 43.4613V45.1921H68.2693C69.2252 45.1921 70 44.4172 70 43.4613H63.0771Z",
    fill: "#9AFF42"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3464 43.4613V45.1921H63.0771V43.4613H61.3464Z",
    fill: "#9AFF42"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3464 33.0768H59.6157V34.8076H61.3464V33.0768Z",
    fill: "#9AFF42"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6157 26.1538V33.0768H61.3464V27.8845C61.3464 26.9287 60.5715 26.1538 59.6157 26.1538Z",
    fill: "#9AFF42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvcIcon7);
export default __webpack_public_path__ + "static/media/svc_icon7.4d17e10d42b94a8ea24776661f43335e.svg";
export { ForwardRef as ReactComponent };